function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7498 0.5C11.2998 0.5 9.90817 1.175 8.99984 2.24167C8.0915 1.175 6.69984 0.5 5.24984 0.5C2.68317 0.5 0.666504 2.51667 0.666504 5.08333C0.666504 8.23333 3.49984 10.8 7.7915 14.7L8.99984 15.7917L10.2082 14.6917C14.4998 10.8 17.3332 8.23333 17.3332 5.08333C17.3332 2.51667 15.3165 0.5 12.7498 0.5ZM9.08317 13.4583L8.99984 13.5417L8.9165 13.4583C4.94984 9.86667 2.33317 7.49167 2.33317 5.08333C2.33317 3.41667 3.58317 2.16667 5.24984 2.16667C6.53317 2.16667 7.78317 2.99167 8.22484 4.13333H9.78317C10.2165 2.99167 11.4665 2.16667 12.7498 2.16667C14.4165 2.16667 15.6665 3.41667 15.6665 5.08333C15.6665 7.49167 13.0498 9.86667 9.08317 13.4583Z",
  fill: "black"
});

function SvgNotFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFavorite);
export default __webpack_public_path__ + "static/media/notFavorite.6978b3d1.svg";
export { ForwardRef as ReactComponent };